module.exports = __webpack_public_path__ + "static/img/gongzhong.900c6e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/gongzhong.jpg
// module id = +F6g
// module chunks = 1